/**
 * Analytics bucket helpers — shared utilities for creating
 * privacy-safe bucket values for analytics events.
 */

export function resultsBucket(count: number): "0" | "1-3" | "4-10" | "10+" {
  if (count === 0) return "0";
  if (count <= 3) return "1-3";
  if (count <= 10) return "4-10";
  return "10+";
}

export function spotsBucket(maxSpots: number | null | undefined): "unlimited" | "1-5" | "6-20" | "20+" {
  if (!maxSpots || maxSpots <= 0) return "unlimited";
  if (maxSpots <= 5) return "1-5";
  if (maxSpots <= 20) return "6-20";
  return "20+";
}

export function spotsRequestedBucket(spots: number): "1" | "2" | "3+" {
  if (spots <= 1) return "1";
  if (spots === 2) return "2";
  return "3+";
}

export function fileSizeBucket(bytes: number): "<1mb" | "1-5mb" | "5-20mb" | "20mb+" {
  const mb = bytes / (1024 * 1024);
  if (mb < 1) return "<1mb";
  if (mb < 5) return "1-5mb";
  if (mb < 20) return "5-20mb";
  return "20mb+";
}

export function mimeGroup(mime: string): "image" | "video" | "other" {
  if (mime.startsWith("image/")) return "image";
  if (mime.startsWith("video/")) return "video";
  return "other";
}

export function classifyFailure(error: unknown): string {
  if (!error) return "unknown";
  const msg = error instanceof Error ? error.message : String(error);
  if (msg.includes("403") || msg.includes("rls")) return "rls_403";
  if (msg.includes("validation") || msg.includes("invalid")) return "validation";
  if (msg.includes("network") || msg.includes("fetch") || msg.includes("Failed to fetch")) return "network";
  if (msg.includes("fullbok") || msg.includes("full")) return "fullbooked";
  if (msg.includes("deadline") || msg.includes("stängd")) return "deadline";
  if (msg.includes("too_large") || msg.includes("stor")) return "too_large";
  if (msg.includes("storage")) return "storage";
  return "unknown";
}
